import { AuthSandbox } from './core/auth/auth.sandbox';
import { AuthApiService } from './core/auth/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SWIPER_CONFIG, SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RequestInterceptor, HTTPStatus } from './core/providers/interceptor/request.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './default/shared/shared.module';
import { LayoutComponent } from './default/common/layout/layout.component';
import { reducers, metaReducers } from '../app/core/app.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './core/providers/guards/auth-guard';
import { MediaSandbox } from './core/media/media.sandbox';
import { MediaService } from './core/media/media.service';
import { MediaEffects } from './core/media/effects/media.effect';
// import { LocationStrategy, HashLocationStrategy } from '@angular/core';
import { CommonSandbox } from './core/common/common.sandbox';
import { CommonService } from './core/common/common.service';
import { CommonEffect } from './core/common/effects/common.effect';
import { AuthEffects } from './core/auth/effects/auth.effect';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from './default/shared/interfaces/dateformat';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// import { ConnectionServiceModule } from 'ng-connection-service';
import { ADD_ON_EFFECT } from '../../add-ons/add-ons.effect';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { PaymentEffect } from './core/payment/payment-effects/payment.effects';
import { PaymentSandbox } from './core/payment/payment.sandbox';
import { PaymentService } from './core/payment/payment.service';
import { PayoutModule } from './default/pages/component/sales/manage-accounts/payout/payout.module';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

const commonEffect = [MediaEffects, CommonEffect, AuthEffects,PaymentEffect];

const effectArray = [...commonEffect, ...ADD_ON_EFFECT];

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SwiperModule,
    SharedModule,
    BrowserAnimationsModule,
    InfiniteScrollModule,
    HttpClientModule,
    PayoutModule,
    // ConnectionServiceModule,
    EffectsModule.forRoot(effectArray),
    StoreModule.forRoot(reducers, { metaReducers, runtimeChecks: { strictStateImmutability: false, strictActionImmutability: false } }),

    ToastrModule.forRoot({
      timeOut: 2000,
      easing: 'ease-in',
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    FormsModule
  ],
  providers: [
    HTTPStatus,
    MediaSandbox,
    MediaService,
    CommonSandbox,
    CommonService,
    AuthSandbox,
    AuthApiService,
    PaymentSandbox,
    PaymentService,
    AuthGuard,
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
